export default __webpack_public_path__ + "static/media/Summoner's Girdle of Imperial Assent.51bab9ed.jpg";